// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumbs_container__J+yud","chevron":"Breadcrumbs_chevron__kFBUN","crumb":"Breadcrumbs_crumb__gjZ-3","link":"Breadcrumbs_link__axUO+"};